import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  const [featured, ...rest] = posts;

  return (
    <div className="pt-32 pb-24 bg-background" data-testid="blog-list-page">
      <section className="container-page">
        <div className="grid md:grid-cols-12 gap-6 mb-14">
          <div className="md:col-span-7">
            <div className="overline copper mb-4">Journal · Le mag de l'électricien</div>
            <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95]">
              Conseils, normes<br/>et chantiers décryptés.
            </h1>
          </div>
        </div>

        {featured && (
          <Link
            to={`/blog/${featured.slug}`}
            className="block group border border-border bg-card mb-12"
            data-testid={`blog-featured-${featured.slug}`}
          >
            <div className="grid md:grid-cols-2 gap-0">
              <div className="img-hover aspect-[4/3] md:aspect-auto bg-muted">
                <img src={featured.image_url} alt={featured.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <div className="overline copper mb-4">À la une · {featured.category}</div>
                <h2 className="font-display font-bold text-2xl md:text-4xl tracking-tight leading-[1.1]">
                  {featured.title}
                </h2>
                <p className="mt-5 text-muted-foreground leading-relaxed">{featured.excerpt}</p>
                <div className="mt-8 flex items-center gap-6 text-sm font-mono text-muted-foreground">
                  <span>{new Date(featured.published_at).toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}</span>
                  <span className="flex items-center gap-2"><Clock size={13} /> {featured.read_minutes} min</span>
                </div>
                <div className="mt-8 inline-flex items-center gap-2 font-semibold copper">
                  Lire l'article <ArrowUpRight size={16} strokeWidth={2.5} />
                </div>
              </div>
            </div>
          </Link>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rest.map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug}`}
              className="block bg-card border border-border group"
              data-testid={`blog-card-${p.slug}`}
            >
              <div className="img-hover aspect-[16/10] bg-muted">
                <img src={p.image_url} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="overline copper">{p.category}</span>
                  <span className="font-mono text-xs text-muted-foreground">{p.read_minutes} min</span>
                </div>
                <h3 className="font-display font-bold text-lg tracking-tight leading-tight group-hover:copper transition-colors">{p.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed line-clamp-2">{p.excerpt}</p>
                <div className="mt-4 font-mono text-xs text-muted-foreground">
                  {new Date(p.published_at).toLocaleDateString("fr-FR", { year: "numeric", month: "short", day: "numeric" })}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
